import type { IconProps } from './types';
import './icons.css';

export default function Left({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 7}
      height={height || 10}
      viewBox="0 0 7 10"
      className={`icon icon-left ${className || ''}`}
      fill="none"
    >
      <path d="M6 9L2 5L6 1" stroke="currentColor" />
    </svg>
  );
}
